__turbopack_context__.v({
  "icon": "SocialMediaIcon-module-scss-module__syLbNW__icon",
  "icon_link": "SocialMediaIcon-module-scss-module__syLbNW__icon_link",
});
